import { render, staticRenderFns } from "./ChooseMerchant.vue?vue&type=template&id=11cd7519&"
import script from "./ChooseMerchant.vue?vue&type=script&lang=js&"
export * from "./ChooseMerchant.vue?vue&type=script&lang=js&"
import style0 from "./ChooseMerchant.vue?vue&type=style&index=0&id=11cd7519&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports